<template>
  <component :is="tag" class="ak-doc-rich" :class="contentClass" v-html="html" />
</template>

<script setup>
defineOptions({ name: 'ApiDocsRichText' })

defineProps({
  html: { type: String, default: '' },
  tag: { type: String, default: 'div' },
  contentClass: { type: [String, Object, Array], default: '' },
})
</script>
